<template>
  <transition name="fade">
    <div class="flex flex-col items-center justify-center absolute w-full h-full pin-y pin-l z-1010 bg-overlay p-2" ref="modal" @keyup.esc="close" tabindex="0">
      <div class="rounded bg-white relative w-full p-4 pt-6 lg:pt-4">
        <div class="absolute pin-t pin-r mr-2 mt-2 cursor-pointer" @click="close">
          <v-icon scale="1" class="self-center" name="times" color="#6f6f70" />
        </div>
        <div class="">
          <div class="flex flex-row justify-start items-center">
            <h3 class="text-grey-darkest text-sm">Daftar Nama Guru yang Akan Diredistribusi</h3>
            <button v-if="mutations.length" class="flex-no-shrink bg-indigo hover:bg-indigo-dark text-white text-xs font-bold py-1 px-2 rounded ml-4 flex items-center" @click="downloadCsv">
              <div class="mr-1"><v-icon scale="0.5" name="download" class="text-white" /></div>
              <div class="">Download CSV</div>
            </button>
          </div>
          <div class="flex">
            <div class="flex-1 text-grey-darker text-sm mt-2 overflow-x-auto">
              <table class="table-auto w-full">
                <thead class="text-center">
                  <tr>
                    <th class="p-1 bg-grey-lighter font-sans text-sm text-grey-dark border border-grey-light">No</th>
                    <th class="p-1 bg-grey-lighter font-sans text-sm text-grey-dark border border-grey-light">Nama Guru</th>
                    <th class="p-1 bg-grey-lighter font-sans text-sm text-grey-dark border border-grey-light">Asal Sekolah</th>
                    <th class="p-1 bg-grey-lighter font-sans text-sm text-grey-dark border border-grey-light">Zonasi</th>
                    <th class="p-1 bg-grey-lighter font-sans text-sm text-grey-dark border border-grey-light">Mata Pelajaran yang Diajar Saat Ini</th>
                    <th class="p-1 bg-grey-lighter font-sans text-sm text-grey-dark border border-grey-light">Status Sertifikasi</th>
                    <th class="p-1 bg-grey-lighter font-sans text-sm text-grey-dark border border-grey-light">Sekolah Tujuan</th>
                    <th class="p-1 bg-grey-lighter font-sans text-sm text-grey-dark border border-grey-light">Zonasi</th>
                    <th class="p-1 bg-grey-lighter font-sans text-sm text-grey-dark border border-grey-light">Mata Pelajaran yang akan Diajar</th>
                    <th v-if="isMutationAllowed" class="p-1 bg-grey-lighter font-sans text-sm text-grey-dark border border-grey-light">Aksi</th>
                  </tr>
                </thead>
                <tbody class="text-left" v-if="mutations.length">
                  <tr class="hover:bg-blue-lightest" v-for="(mutation, index) in mutations" :key="index">
                    <td class="p-1 border border-grey-light text-center">{{ index + paginationData.from }}</td>
                    <td class="p-1 border border-grey-light whitespace-no-wrap">{{ mutation.properties.teacher.nama }}</td>
                    <td class="p-1 border border-grey-light whitespace-no-wrap">{{ mutation.properties.origin.nama }}</td>
                    <td class="p-1 border border-grey-light">{{ mutation.properties.origin.kode_zona }}</td>
                    <td class="p-1 border border-grey-light">{{ mutation.properties.origin.mata_pelajaran }}</td>
                    <td class="p-1 border border-grey-light">{{ mutation.properties.teacher.sertifikasi }}</td>
                    <td class="p-1 border border-grey-light whitespace-no-wrap">{{ mutation.properties.destination.nama }}</td>
                    <td class="p-1 border border-grey-light">{{ mutation.properties.destination.kode_zona }}</td>
                    <td class="p-1 border border-grey-light">{{ mutation.properties.destination.mata_pelajaran }}</td>
                    <td v-if="isMutationAllowed" class="p-1 border border-grey-light">
                      <button class="bg-warning hover:bg-warning-dark text-white text-xs font-bold py-1 px-2 rounded" @click="cancelMutation(mutation)">
                        Batalkan Redistribusi
                      </button>
                    </td>
                  </tr>
                </tbody>
                <tbody class="text-left" v-else>
                  <tr class="hover:bg-blue-lightest">
                    <td class="p-1 border border-grey-light text-center" colspan="10">Tidak ada data</td>
                  </tr>
                </tbody>
              </table>
              <div class="mt-2">
                <pagination v-if="paginationData.lastPage > 1" :pagination="paginationData" :offset="offset" @paginate="fetchMutations()"></pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapState } from 'vuex'
import {
  TOGGLE_MODAL_MUTATIONS
} from '@/mutationTypes'
import Pagination from '@/components/Pagination'

export default {
  name: 'modal-mutation',
  components: {
    pagination: Pagination
  },
  mounted () {
    this.$nextTick(() => this.$refs.modal.focus())
    this.fetchMutations()
  },
  computed: {
    ...mapState(['user', 'modalMutationsType', 'selectedDistrict']),
    isMutationAllowed () {
      if (this.user.role === 'district' && (this.selectedDistrict.kode_wilayah !== this.user.district.properties.kode_wilayah)) {
        return false
      }
      return true
    }
  },
  data () {
    return {
      mutations: [],
      limit: 10,
      offset: 10,
      paginationData: {
        currentPage: 1
      }
    }
  },
  methods: {
    close () {
      this.$store.dispatch(TOGGLE_MODAL_MUTATIONS, {
        status: false,
        type: null
      })
    },
    async fetchMutations () {
      try {
        let response
        if (this.modalMutationsType === 'all') {
          response = await fetch(process.env.VUE_APP_API_URL + '/api/simrasio/mutationRecord/' + this.limit + '/' + this.paginationData.currentPage)
        } else {
          response = await fetch(process.env.VUE_APP_API_URL + '/api/simrasio/mutationRecordByDistrict/' + this.selectedDistrict.kode_wilayah + '/' + this.limit + '/' + this.paginationData.currentPage)
        }
        let json = await response.json()
        if (json.status === 200) {
          this.mutations = json.result.mutations
          this.paginationData = json.result.pagination
        }
      } catch (err) {
        // console.log(err)
      }
    },
    async cancelMutation (mutation) {
      try {
        let url = process.env.VUE_APP_API_URL + '/api/simrasio/deleteMutation/' + mutation.id
        let response = await fetch(url, {
          method: 'DELETE'
        })
        let json = await response.json()
        if (json.status === 200) {
          this.mutations.splice(this.mutations.findIndex(item => item.id === mutation.id), 1)
        }
      } catch (err) {

      }
    },
    async downloadCsv () {
      window.location.href = process.env.VUE_APP_API_URL + '/api/simrasio/downloadMutationsByDistrict/csv/' + this.selectedDistrict.kode_wilayah
    }
  }
}
</script>
